/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';

import WelcomePage from '../WelcomePage/WelcomePage';

// Need to define messages used by our server here/need to refactor our login to be react side comp
const messages = defineMessages({
  serviceBrokerError: 'There was an error loading data for this tenant.',
  invalidTenant: 'Your tenant `{tenantId}` is invalid. Check your URL.',
  loginError: 'Login error',
  close: 'close',
});

const propTypes = {
  isTenantValid: PropTypes.bool,
  tenantId: PropTypes.string.isRequired,
  docURL: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  isTenantValid: undefined,
};

const LoginError = ({ intl: { formatMessage }, docURL, title, isTenantValid, tenantId }) => (
  <section>
    <Helmet>
      <title>{`${title} | ${formatMessage(messages.invalidTenant, { tenantId })}`}</title>
    </Helmet>
    <WelcomePage
      title={title}
      tenantId={tenantId}
      docURL={docURL}
      errorMessageType="error"
      errorMessage={formatMessage(messages.loginError)}
      errorMessageDetails={
        !isTenantValid
          ? formatMessage(messages.invalidTenant, { tenantId })
          : formatMessage(messages.serviceBrokerError)
      }
    />
  </section>
);

LoginError.defaultProps = defaultProps;
LoginError.propTypes = propTypes;
export default injectIntl(LoginError);
